<template>
  <div class="locations-card desktop-shadow-card desktop-white-bg rounded">
    <div class="card-header">
      <h4 class="card-header-title">
        <icon type="map-marker-alt" class="mr-2" />Locations
      </h4>
      <button
        @click="addLocation()"
        v-if="userHasControl && !loading"
        class="btn btn-sm btn-success"
      >
        <i class="fas fa-plus mr-2"></i>Add Location
      </button>
    </div>
    <alert
      v-if="!loading && locations.locations.length == 0"
      class="m-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
      >No Locations</alert
    >
    <alert
      v-if="loading"
      type="loader"
      color="light"
      class="m-4 mobile-tablet-white-bg mobile-tablet-shadow-card"
    />
    <table
      class="table table-sm table-striped table-hover mb-0"
      v-if="!loading && locations.locations.length > 0"
    >
      <thead>
        <tr>
          <th>Clinic/Facility/Professional Name</th>
          <th>Street</th>
          <th>City</th>
          <th>Province</th>
          <th>Postal Code</th>
          <th v-if="userHasControl" style="min-width: 106px"></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="loc in locations.locations"
          :key="loc.id"
          class="mobile-tablet-shadow-card rounded"
        >
          <td>
            <b class="mobile-tablet-only mr-2"
              >Clinic/Facility/Professional Name:</b
            >{{ loc.clinic_name }}
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Street:</b>{{ loc.street }}
            {{ loc.unit }}
          </td>
          <td><b class="mobile-tablet-only mr-2">City:</b>{{ loc.city }}</td>
          <td>
            <b class="mobile-tablet-only mr-2">Province:</b>{{ loc.state }}
          </td>
          <td>
            <b class="mobile-tablet-only mr-2">Postal Code:</b>{{ loc.zip }}
          </td>
          <td class="text-right actions-td" v-if="userHasControl">
            <button class="btn btn-sm btn-info mr-2" @click="editLocation(loc)">
              <i class="fas fa-edit fa-fw" v-if="!loc.editing" title="edit"></i>
              <i
                class="fas fa-spin fa-circle-notch fa-fw"
                v-if="loc.editing"
              ></i>
              <span class="mobile-tablet-only pl-2">Edit</span>
            </button>
            <button class="btn btn-sm btn-danger" @click="deleteLocation(loc)">
              <i
                class="fas fa-trash fa-fw"
                v-if="!loc.deleting"
                title="delete"
              ></i>
              <i
                class="fas fa-spin fa-circle-notch fa-fw"
                v-if="loc.deleting"
              ></i>
              <span class="mobile-tablet-only pl-2">Delete</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <add-location :vendor="vendor.id" v-if="modal.showing" />
  </div>
</template>
<script>
import AddLocation from "./AddLocation";
import { mapState } from "vuex";
import Swal from "sweetalert2";
import Auth from "../../../auth";

export default {
  name: "Locations",
  components: {
    AddLocation,
  },
  computed: {
    ...mapState(["locations", "vendors", "modal"]),
    vendor: function () {
      return this.vendors.single;
    },
    loading: function () {
      return this.locations.loading;
    },
    loggedInUser: function () {
      return Auth.user.get();
    },
    userHasControl: function () {
      if (!this.vendor) {
        return false;
      }
      if (
        this.loggedInUser.isAdmin ||
        ((this.vendor.admins || []).length &&
          this.vendor.admins.includes(this.loggedInUser.id))
      ) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    if (!this.vendors.single) {
      this.$store.dispatch("vendors/get", { id: this.$route.params.id });
    }
    this.get(this.$route.params.id);
  },
  methods: {
    get: function (id) {
      this.$store.dispatch("locations/get", id);
    },
    addLocation: function () {
      this.$store.dispatch("showModal", "add-location");
    },
    deleteLocation: function (loc) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            loc.deleting = true;
            this.$store.dispatch("locations/delete", loc);
          }
        });
    },
    editLocation: function (loc) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success mr-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Edit Clinic/Facility/Professional Name",
          input: "text",
          inputLabel: "Clinic/Facility/Professional Name",
          inputValue: loc.clinic_name,
          showCancelButton: true,
          confirmButtonText: "Edit",
          cancelButtonText: "Cancel",
          inputValidator: (value) => {
            if (!value) {
              return "Add Clinic Name";
            }
          },
        })
        .then((result) => {
          if (result.value) {
            loc.editing = true;
            this.$forceUpdate();
            this.$store
              .dispatch("locations/update", {
                ...loc,
                clinic_name: result.value,
              })
              .then((success) => {
                if (success) {
                  loc.clinic_name = result.value;
                }
                loc.editing = false;
                this.$forceUpdate();
              });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 1024px) {
  .locations-card {
    .card-header {
      padding: 0 !important;
    }
    table {
      display: flex;
    }
    thead {
      display: none;
    }
    tbody {
      width: 100%;
    }
    tr {
      display: flex;
      flex-direction: column;
      margin-bottom: 24px;
      padding: 8px;
      box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 3%);
      td {
        padding: 0 4px;
        text-align: left !important;
        border: 0 !important;
        b {
          display: inline-block;
          padding: 4px 0;
        }

        &.actions-td {
          text-align: center !important;
          margin-bottom: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #ccc !important;
        }
      }
    }
  }
}
</style>
